export default __webpack_public_path__ + "images/acf61b37ff68a9c2b9fde6f071431cc5.png";